import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "./ui/dialog";
import { Loader2 } from "lucide-react";

export function ChangePasswordDialog({ open, onOpenChange, forced = false }) {
  const { changePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setError("");
    if (next.length < 6) return setError("New password must be at least 6 characters.");
    if (next !== confirm) return setError("Passwords do not match.");
    setSaving(true);
    const res = await changePassword(current, next);
    setSaving(false);
    if (res.ok) {
      toast.success("Password updated");
      setCurrent(""); setNext(""); setConfirm("");
      onOpenChange(false);
    } else {
      setError(res.error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!forced) onOpenChange(o); }}>
      <DialogContent data-testid="change-password-dialog" onInteractOutside={(e) => forced && e.preventDefault()} onEscapeKeyDown={(e) => forced && e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{forced ? "Set a new password" : "Change password"}</DialogTitle>
          <DialogDescription>
            {forced
              ? "Your account was created with a temporary password. Please set your own password to continue."
              : "Update the password you use to sign in."}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Current password</Label>
            <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current" />
          </div>
          <div className="space-y-1.5">
            <Label>New password</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new" />
          </div>
          <div className="space-y-1.5">
            <Label>Confirm new password</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="cp-error">{error}</p>}
        </div>
        <DialogFooter>
          {!forced && <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>}
          <Button className="bg-brand hover:bg-brand-dark" onClick={submit} disabled={saving} data-testid="cp-submit">
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Update password
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
